import { Box, Flex, Text } from "@chakra-ui/react";
import { IconType } from "react-icons";
import OptionCard from "./OptionCard";

export type Option = {
  key: string;
  icon?: IconType;
  title: string;
  description: string;
};

type OptionSectionProps = {
  title: string;
  options: Option[];
  selected: string;
  onSelect: (key: string) => void;
};

// One "pick one of N cards" section of the service creator (Kategória,
// Időpontok, Ár, Helyszín, Várólista, Foglalási beállítások in the real
// screen). Shows the selected option's own description as the helper line
// underneath, exactly like the real form does.
const OptionSection = ({ title, options, selected, onSelect }: OptionSectionProps) => {
  const active = options.find((o) => o.key === selected) ?? options[0];
  return (
    <Box bg="white" border="1px solid" borderColor="chalk.300" borderRadius="lg" p={{ base: 2.5, sm: 3 }} mb={2.5}>
      <Text fontSize="9px" fontWeight="700" color="ink.900" mb={2}>
        {title}
      </Text>
      <Flex gap={1.5} wrap={{ base: "wrap", sm: "nowrap" }}>
        {options.map((o) => (
          <OptionCard
            key={o.key}
            icon={o.icon}
            title={o.title}
            description={o.description}
            selected={selected === o.key}
            onClick={() => onSelect(o.key)}
          />
        ))}
      </Flex>
      <Text fontSize="7px" color="slate.500" mt={2}>
        {active.description}
      </Text>
    </Box>
  );
};

export default OptionSection;
